var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-image" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: "主图管理",
            width: "80%",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "div",
            { staticClass: "image-tip" },
            [
              _c("el-alert", {
                attrs: {
                  title: "主图必须上传3张或以上",
                  type: "warning",
                  "show-icon": "",
                  closable: false,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "SortImg",
            {
              ref: "sortImgRef",
              attrs: { imgUrlList: _vm.list, changeList: _vm.changeList },
            },
            [
              _c("i", {
                staticClass: "el-icon-camera cameraIconfont",
                on: { click: _vm.upLoad },
              }),
            ]
          ),
          _vm._v(" "),
          _c("el-alert", {
            staticClass: "image-upload-tip",
            attrs: {
              closable: false,
              title: "建议上传分辨率为800×800px的图片，大小≤500KB",
              type: "warning",
              "show-icon": "",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.comfirm } },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }